"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var path_browserify_1 = __importDefault(require("path-browserify"));

function renamePathPrefix(filename, from, to) {
  if (filename === from) return to;
  var fromParentFolder = path_browserify_1.default.join(from, '/');
  var toParentFolder = path_browserify_1.default.join(to, '/');

  if (filename.startsWith(fromParentFolder)) {
    return filename.replace(fromParentFolder, toParentFolder);
  }

  return filename;
}

exports.renamePathPrefix = renamePathPrefix;